import { Controller } from '@hotwired/stimulus';

import { phoneNumberFormatter } from '../../../lib/intlTelInput.js';

export default class PhoneNumberController extends Controller {
  static targets = ['phoneInput'];

  phoneInputTargetConnected() {
    phoneNumberFormatter({
      inputId: `#${this.phoneInputTarget.id}`,
      phoneAttributeName: this.phoneInputTarget.name,
    });
  }
}
